import { Box, Typography } from '@mui/material'
import React from 'react'

function Forbidden() {
  return (
   <>
   <Box sx={{width:'100%', height:'100vh', backgroundColor:'#fff', margin:'auto',display:'flex', justifyContent:'center', alignItems:'center'}}>
<Typography variant='h4' className='black-color fw-700'>
Forbidden: You do not have permission to access this resource.
</Typography>
   </Box>
   </>
  )
}

export default Forbidden
